import { PersoanlService } from './../../../../data/repository/plan-repository/persoanl.service';
import { PersonalDataService } from './../../../../data/repository/plan-repository/personal-data.service';
import { Component, OnInit, Input } from '@angular/core';
import { ResponseGetRatioArray } from 'src/app/core/model/api-response/persoanl-response-model';

@Component({
  selector: 'app-personal-bottomsheet',
  templateUrl: './personal-bottomsheet.component.html',
  styleUrls: ['./personal-bottomsheet.component.scss'],
})
export class PersonalBottomsheetComponent implements OnInit {
  @Input() show: boolean = false;
  title: string = 'افزودن واحد و مقدار';
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  selecting: boolean = false;
  selectedUnit: ResponseGetRatioArray = null;
  calorie: number = null;
  foodUnitArray: ResponseGetRatioArray[] = null;
  active: boolean = false;
  edditing: boolean = false;
  constructor(
    private personalDataService: PersonalDataService,
    private persoanlService: PersoanlService
  ) {
    this.persoanlService.getFoodUnitId().then((res) => {
      this.foodUnitArray = res
        .getData()
        .getFoodUnitId()
        .filter((d) => {
          if (
            this.personalDataService.ids &&
            this.personalDataService.ids.length > 0 &&
            this.personalDataService.ids.includes(d._id)
          ) {
            return;
          }
          return d;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    });
    const ratio = this.personalDataService.editRatio;
    if (ratio) {
      this.edditing = true;
      this.calorie = ratio[0].ratio;
      this.selectedUnit = ratio[1];
      this.chekButtom();
    }
  }
  ngOnInit() {}
  closeBottomSheet() {
    setTimeout(() => {
      this.personalDataService.closeBottomSheet();
    }, 500);
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      if (this.selecting) {
        setTimeout(() => {
          this.selecting = false;
        }, 500);
      } else {
        this.show = false;
        this.closeBottomSheet();
      }
    }
  }
  submit() {
    if (this.active) {
      console.log(this.selectedUnit);

      this.personalDataService.closeAndUpdateBottomSheet(
        this.selectedUnit,
        this.calorie
      );
    }
  }
  selectUnitItem(d: ResponseGetRatioArray) {
    this.selectedUnit = d;
    this.swipe(this.SWIPE_ACTION.DOWN);
    this.chekButtom();
  }
  selectUnit() {
    this.title = 'واحد غذا';
    this.selecting = true;
  }
  chekButtom() {
    if (this.calorie >= 0 && this.selectedUnit) {
      this.active = true;
    } else {
      this.active = false;
    }
  }
  remove() {
    if (this.edditing) {
      this.personalDataService.closeAndRemove(this.selectedUnit.id);
    }
  }
}
